(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ncs-faq"] && !Shopify.designMode) return;
  try {
    
  // FAQ accordion: one panel open at a time, first item open on load.
  function initNcsFaq(root) {
    if (!root || root.dataset.ncsFaqReady === 'true') return;
    root.dataset.ncsFaqReady = 'true';

    var buttons = Array.prototype.slice.call(root.querySelectorAll('.ncs-faq__q'));
    if (!buttons.length) return;

    // Only collapse once the script is running, so a JS failure leaves every answer readable.
    root.classList.add('is-enhanced');

    function setOpen(button, open) {
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    buttons.forEach(function (button, index) {
      setOpen(button, index === 0);
      button.addEventListener('click', function () {
        var wasOpen = button.getAttribute('aria-expanded') === 'true';
        buttons.forEach(function (other) {
          setOpen(other, false);
        });
        setOpen(button, !wasOpen);
      });
    });
  }

  function initAllNcsFaq() {
    document.querySelectorAll('[data-ncs-faq]').forEach(initNcsFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllNcsFaq);
  } else {
    initAllNcsFaq();
  }

  // Theme editor re-renders the section without a page load.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-ncs-faq]');
    if (root) initNcsFaq(root);
  });

  } catch(e) { console.error(e); }
})();
})();
